import { render, staticRenderFns } from "./CheckoutSkeleton.vue?vue&type=template&id=5174b00c&scoped=true&"
import script from "./CheckoutSkeleton.vue?vue&type=script&lang=ts&"
export * from "./CheckoutSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutSkeleton.vue?vue&type=style&index=0&id=5174b00c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174b00c",
  null
  
)

export default component.exports